export default __webpack_public_path__ + "static/media/InstagramBlack-removebg-preview.b3d1dc08.png";